import { useEffect } from 'react';

import type { PublicPluginAPI } from '@atlaskit/editor-common/types';
import type { ConnectivityPlugin } from '@atlaskit/editor-plugin-connectivity';

export interface Options {
	collabEditInternetLost: boolean;
	internetDisconnected: boolean;
	editorFullPagePresetAPI: PublicPluginAPI<[ConnectivityPlugin]> | undefined;
}

/**
 * Override the default connectivity behaviour to keep it in sync with whether or not
 * the collaborative provider is connected or not.
 *
 * This is required because sometimes the internet will reconnect, but the provider gets stuck.
 */
export const useEditorCollabConnectivitySync = ({
	collabEditInternetLost,
	internetDisconnected,
	editorFullPagePresetAPI,
}: Options) => {
	useEffect(() => {
		if (internetDisconnected) {
			// Internet is actually disconnected (network issue)
			editorFullPagePresetAPI?.core.actions.execute(
				editorFullPagePresetAPI?.connectivity?.commands.setMode('internet-offline'),
			);
		} else if (collabEditInternetLost) {
			// Collaboration connection lost but internet might be available
			editorFullPagePresetAPI?.core.actions.execute(
				editorFullPagePresetAPI?.connectivity?.commands.setMode('collab-offline'),
			);
		} else {
			// Both are false, we're online
			editorFullPagePresetAPI?.core.actions.execute(
				editorFullPagePresetAPI?.connectivity?.commands.setMode('online'),
			);
		}
	}, [collabEditInternetLost, internetDisconnected, editorFullPagePresetAPI]);
};
